<div
  aria-labelledby="headPrimary3"
  class="common-va-widget-bg"
  id="primaryPanel3"
  role="tabpanel"
>
  <div
    [ngClass]="{ 'mytrips-top': !tripDetails?.hasUpComingTrip }"
    class="container mytrips-widget-container container-padding-x"
  >
    <div
      *ngIf="!isFindMyTripClicked && aemErrorMsgDetails"
      class="system-error-message-conteiner"
    >
      <span class="system-error-message">
        <!--<span class="icon-alert-icon">
                  <span class="path1"></span>
                  <span class="path2"></span>
              </span>-->
        {{ aemErrorMsgDetails }}
      </span>
    </div>
    <div
      #upcomingTrip
      [ngClass]="{
        'd-none': !tripDetails?.hasUpComingTrip || !isFindMyTripClicked,
        'upcoming-trips-pl-0': tripDetails?.hasUpComingTrip
      }"
      class="upcoming-trip ml-lg-0 offset-md-2"
    >
      <a
        (click)="toggleMyTrip()"
        class="upcoming-link icon-Dropdown-caret"
        for="backToUpcomingTrips"
        href="javascript:void(0);"
      >
        {{ contentMyTrip?.backToUpcomingTripLabel }}
      </a>
    </div>
    <form
      #formStoreDir="ngcFormStore"
      #ngCheckinWidgetForm
      (ngSubmit)="onSubmit($event)"
      [action]="formAction"
      [formGroup]="mytripWidgetForm"
      [makeVisible]="isSubmitted"
      [ngClass]="{ 'my-trips-form': tripDetails?.hasUpComingTrip }"
      [ngc-form-store]="'mytripWidgetForm'"
      [ngc-formNameToValidate]="'mytripWidgetForm'"
      [ngc-formToValidate]="mytripWidgetForm"
      autocomplete="off"
      class="ml-xl-0 ml-xxl-0"
      method="POST"
      ngc-error-handler
      novalidate
    >
      <ngc-make-correction></ngc-make-correction>
      <div
        [ngClass]="{
          'd-none': tripDetails?.hasUpComingTrip && !isFindMyTripClicked
        }"
        class="form-row align-items-start"
      >
        <div
          *ngIf="deviceTypes?.isDesktop"
          [ngClass]="{ 'pl-sm-0': tripDetails?.hasUpComingTrip }"
          class="col-lg-4 select_dropdown offset-md-2 col-md-8 offset-lg-0 pl-xl-0"
        >
          <label class="sr-only" for="searchOption">Find Your Trip By</label>
          <select
            #tripTypesDropdown="ngcSelectDirective"
            (change)="selectTrip($event.target.value)"
            (customChangeEvent)="customChangeEventHandler($event)"
            [(ngModel)]="selectTripBy"
            [formControlName]="'searchOption'"
            [ngc-floatinglabel]="
              contentMyTrip ? contentMyTrip.findYourTripBy : 'Find Your Trip By'
            "
            [selectedIndex]="getSelectedIndex()"
            autorotateoption="true"
            class="drop-down first-control form-control"
            customClassName="blue-theme"
            customClassNameFocus="focusable-element"
            customLoadingCheck="true"
            data-dluiSelect
            id="searchOption"
            name="searchOption"
            openonenter="true"
          >
            <option
              *ngFor="let tripType of tripTypes"
              [value]="tripType.mytripssearchbyid"
            >
              {{ tripType.mytripssearchbytitle }}
            </option>
          </select>
        </div>
        <div
          *ngIf="!deviceTypes.isDesktop"
          [ngClass]="{ 'pl-sm-0': tripDetails?.hasUpComingTrip }"
          class="col-lg-4 select_dropdown offset-md-2 col-md-8 offset-lg-0 pl-xxl-0 select-container-down-md"
        >
          <label class="sr-only" for="searchOption">Find Your Trip By</label>
          <select
            (change)="selectTrip($event.target.value)"
            (customChangeEvent)="customChangeEventHandler($event)"
            [(ngModel)]="selectTripBy"
            [formControlName]="'searchOption'"
            [ngc-floatinglabel]="
              contentMyTrip ? contentMyTrip.findYourTripBy : 'Find Your Trip By'
            "
            [selectedIndex]="getSelectedIndex()"
            autorotateoption="true"
            class="drop-down first-control form-control"
            customClassName="blue-theme"
            customLoadingCheck="true"
            id="searchOption"
            name="searchOption"
            openonenter="true"
          >
            <option
              *ngFor="let tripType of tripTypes"
              [value]="tripType.mytripssearchbyid"
            >
              {{ tripType.mytripssearchbytitle }}
            </option>
          </select>
          <span class="icon-Dropdown-caret d-lg-none"></span>
        </div>
        <div
          *ngIf="selectTripBy === 'widgetSearchUsingConfirmationNo'"
          [ngClass]="{ 'pl-sm-0': tripDetails?.hasUpComingTrip }"
          class="col-lg-3 offset-md-2 col-md-8 offset-lg-0"
        >
          <input id="tab" name="tab" type="hidden" value="confirmationNo" />
          <input
            #confirmationNo
            (focusout)="
              confirmationNo.value = $event.target.value?.trim().toUpperCase();
              focusOutVal()
            "
            [attr.placeholder]="
              contentMyTrip
                ? contentMyTrip.mytrips.get('widgetSearchUsingConfirmationNo')
                    .mytripseacrhbynumber
                : 'ex. SFTORB'
            "
            [formControlName]="'confirmationNo'"
            [ngc-floatinglabel]="
              contentMyTrip
                ? contentMyTrip.mytrips.get('widgetSearchUsingConfirmationNo')
                    .searchtripsFloatLabel
                : 'Confirmation Number'
            "
            [ngc-isRequired]="true"
            autocomplete="off"
            class="form-control mb-2 mb-sm-0 input-mobile-tab-class"
            id="confirmationNo"
            name="confirmationNo"
            ondrop="return false"
            type="{{
              contentMyTrip
                ? contentMyTrip.mytrips.get('widgetSearchUsingConfirmationNo')
                    .mytripSearchByType
                : 'text'
            }}"
          />
          <ngc-validation-error-message
            [control]="mytripWidgetForm?.controls.confirmationNo"
            [controlname]="'confirmationNo'"
            [focusedFieldId]="'confirmationNo'"
            [makeVisible]="isSubmitted"
          ></ngc-validation-error-message>
          <a
            #mytripsconfnoHelp="ngcHelpModalDirective"
            (click)="mytripsconfnoHelp?.openHelpModal()"
            [helpContent]="contentMyTrip?.tooltips?.get('confirmation-number')"
            [type]="'mytripsconfno'"
            aria-haspopup="true"
            class="mytrips-ticketno-help icon-help circle-outline"
            draggable="false"
            href="javascript:void(0);"
            ngc-help-modal-directive
          >
            <span class="sr-only">Confirmation number help</span>
          </a>
        </div>
        <div
          *ngIf="selectTripBy === 'widgetSearchUsingCreditDebitNo'"
          [ngClass]="{ 'pl-sm-0': tripDetails?.hasUpComingTrip }"
          class="col-lg-3 offset-md-2 col-md-8 offset-lg-0"
        >
          <input id="ccTab" name="tab" type="hidden" value="creditCardNo" />
          <input
            [(ngModel)]="credCardCode"
            [ngModelOptions]="{ standalone: true }"
            id="creditcardType"
            name="creditcardType"
            type="hidden"
          />
          <input
            id="findTripsButton"
            name="findTripsButton"
            type="hidden"
            value="findAllTrips"
          />
          <input
            *ngIf="pciFeatureSummary"
            [formControlName]="'paymentReferenceId'"
            name="paymentReferenceId"
            type="hidden"
          />
          <input
            #cardNo
            (creditCardType)="creditCardTypeDetected($event)"
            [attr.placeholder]="
              contentMyTrip
                ? contentMyTrip.mytrips.get('widgetSearchUsingCreditDebitNo')
                    .mytripseacrhbynumber
                : 'ex. 1234123412341234'
            "
            [creditCardNumber]="mytripWidgetForm?.controls.cardNo.value"
            [formControlName]="'cardNo'"
            [ngc-floatinglabel]="
              contentMyTrip
                ? contentMyTrip.mytrips.get('widgetSearchUsingCreditDebitNo')
                    .mytripssearchbytitle
                : 'Card Number'
            "
            [ngc-isRequired]="true"
            autocomplete="off"
            class="form-control mb-2 mb-sm-0 input-mobile-tab-class"
            credCardType
            id="cardNo"
            name="cardNo"
            ondrop="return false"
            type="{{
              contentMyTrip
                ? contentMyTrip.mytrips.get('widgetSearchUsingCreditDebitNo')
                    .mytripSearchByType
                : 'number'
            }}"
            pattern="{{ contentMyTrip?.mytripsRegexPattern }}"
          />
          <ngc-validation-error-message
            [control]="mytripWidgetForm?.controls.cardNo"
            [controlname]="'cardNo'"
            [focusedFieldId]="'cardNo'"
            [makeVisible]="showErrorCardNumber || isSubmitted"
          ></ngc-validation-error-message>
        </div>
        <div
          *ngIf="selectTripBy === 'widgetSearchUsingETicketNo'"
          [ngClass]="{ 'pl-sm-0': tripDetails?.hasUpComingTrip }"
          class="col-lg-3 offset-md-2 col-md-8 offset-lg-0"
        >
          <input id="skyTab" name="tab" type="hidden" value="ticketNo" />
          <input
            #eTicketNo
            [attr.placeholder]="
              contentMyTrip
                ? contentMyTrip.mytrips.get('widgetSearchUsingETicketNo')
                    .mytripseacrhbynumber
                : 'ex. 0062112549881'
            "
            [formControlName]="'eTicketNo'"
            [ngc-floatinglabel]="
              contentMyTrip
                ? contentMyTrip.mytrips.get('widgetSearchUsingETicketNo')
                    .mytripssearchbytitle
                : 'Ticket Number'
            "
            [ngc-isRequired]="true"
            autocomplete="off"
            class="form-control mb-2 mb-sm-0 input-mobile-tab-class"
            id="eTicketNo"
            name="eTicketNo"
            ondrop="return false"
            type="{{
              contentMyTrip
                ? contentMyTrip.mytrips.get('widgetSearchUsingETicketNo')
                    .mytripSearchByType
                : 'number'
            }}"
            pattern="{{ contentMyTrip?.mytripsRegexPattern }}"
          />
          <ngc-validation-error-message
            [control]="mytripWidgetForm?.controls.eTicketNo"
            [controlname]="'eTicketNo'"
            [focusedFieldId]="'eTicketNo'"
            [makeVisible]="isSubmitted"
          ></ngc-validation-error-message>
          <a
            #mytripsticketnoHelp="ngcHelpModalDirective"
            (click)="mytripsticketnoHelp?.openHelpModal()"
            [helpContent]="contentMyTrip?.tooltips?.get('ticket-number')"
            [type]="'mytripsticketno'"
            aria-haspopup="true"
            class="mytrips-ticketno-help icon-help circle-outline"
            draggable="false"
            href="javascript:void(0);"
            ngc-help-modal-directive
          >
            <span class="sr-only">Ticket number help</span>
          </a>
        </div>
        <div
          [ngClass]="{ 'pl-sm-0': tripDetails?.hasUpComingTrip }"
          class="col-lg-2 offset-md-2 col-md-8 offset-lg-0"
        >
          <input
            [attr.placeholder]="
              contentMyTrip ? contentMyTrip.mytripsfirstname : 'First Name'
            "
            [formControlName]="'firstName'"
            [ngc-floatinglabel]="
              contentMyTrip ? contentMyTrip.mytripsFirstNameFloat : 'First Name'
            "
            [ngc-isRequired]="true"
            autocomplete="off"
            class="form-control mb-2 mb-sm-0 text-capitalize input-mobile-tab-class wrap-text"
            id="firstName"
            name="firstName"
            ondrop="return false"
            type="text"
          />
          <ngc-validation-error-message
            [control]="mytripWidgetForm?.controls.firstName"
            [controlname]="'firstName'"
            [focusedFieldId]="'firstName'"
            [makeVisible]="isSubmitted"
          ></ngc-validation-error-message>
        </div>
        <div
          [ngClass]="{ 'pl-sm-0': tripDetails?.hasUpComingTrip }"
          class="col-lg-2 offset-md-2 col-md-8 offset-lg-0"
        >
          <input
            [attr.placeholder]="
              contentMyTrip ? contentMyTrip.mytripslastname : 'Last Name'
            "
            [formControlName]="'lastName'"
            [ngc-floatinglabel]="
              contentMyTrip ? contentMyTrip.mytripslastnameFloat : 'Last Name'
            "
            [ngc-isRequired]="true"
            autocomplete="off"
            class="form-control mb-2 mb-sm-0 text-capitalize input-mobile-tab-class wrap-text"
            id="lastName"
            name="lastName"
            ondrop="return false"
            type="text"
          />
          <ngc-validation-error-message
            [control]="mytripWidgetForm?.controls.lastName"
            [controlname]="'lastName'"
            [focusedFieldId]="'lastName'"
            [makeVisible]="isSubmitted"
          ></ngc-validation-error-message>
        </div>
        <div
          [ngClass]="{ 'pl-sm-0': tripDetails?.hasUpComingTrip }"
          class="pr-lg-0 pr-xl-0 col-lg-1 text-right mt-lg-4 mb-sm-4 mb-lg-2 offset-md-2 col-md-8 offset-lg-0 upcoming-trips-submit"
        >
          <button
            class="btn btn-danger rounded-circle btn-right-arrow icon-submitarrow circle-outline"
            id="btn-mytrip-submit"
            type="submit"
          >
            <span class="sr-only">Submit</span>
          </button>
        </div>
      </div>
      <div
        *ngIf="tripDetails?.hasUpComingTrip"
        [ngClass]="{ 'my-trips-bottom': tripDetails?.hasUpComingTrip }"
        class="form-row"
      >
        <div #singleTrip [ngClass]="{ 'bottom-links': !isFindMyTripClicked }">
          <ngc-mytrips-logged-in
            *ngIf="tripDetails?.hasUpComingTrip && !isFindMyTripClicked"
            [iropAemMessage]="iropAemMessage"
            [isCityNameOnly]="isCityNameOnly"
            [tripContent]="tripContent"
            [tripDetails]="tripDetails"
          ></ngc-mytrips-logged-in>
        </div>
        <div
          [ngClass]="{
            'resrv-link-col-has-trip':
              tripDetails?.hasUpComingTrip && !isFindMyTripClicked,
            'pl-sm-0': tripDetails?.hasUpComingTrip && isFindMyTripClicked
          }"
          class="col-lg-auto resrv-link-col offset-md-2 col-11 col-md-7 col-sm-10 offset-lg-0 ml-lg-0 pl-lg-0"
        >
          <a
            (click)="
              setTrackingObject($event);
              updateToRefreshUrl(tripDetails?.viewAlltrips)
            "
            *ngIf="totalTrips !== 0"
            [attr.target]="
              tripContent.viewAllTripsOpenNewWindow === 'true' ? '_blank' : ''
            "
            [ngClass]="{
              'find-trip-clicked': isFindMyTripClicked,
              'view-all-tab': tripContent?.carReservationLabel
            }"
            class="pl-lg-0 pl-lg-0 ml-lg-0 view-all-link icon-advsearchtriangle"
            for="viewAllTrips"
            href="javascript:void(0);"
          >
            {{ viewAllTitle }}{{ tripDetails?.totaltrips
            }}{{ viewAllTripsTitle }}
          </a>
          <a
            (click)="setTrackingObject($event); toggleMyTrip()"
            *ngIf="tripContent?.findMyTripsTitle"
            [ngClass]="{
              'd-none': !tripDetails?.hasUpComingTrip || isFindMyTripClicked,
              'hotel-resrv-tab-logged-in': tripContent?.carReservationLabel
            }"
            class="hotel-resrv-link-logged-in icon-advsearchtriangle"
            for="findMyTrip"
            href="javascript:void(0);"
          >
            {{ tripContent ? tripContent.findMyTripsTitle : 'Find My Trip' }}
          </a>
          <a
            (click)="setTrackingObject($event)"
            *ngIf="tripContent?.hotelReservationTitle"
            [attr.href]="
              contentMyTrip
                ? contentMyTrip.mytripsHotelreservationUrl
                : 'http://www.hotels-delta.com'
            "
            [attr.target]="
              contentMyTrip?.mytripsHotelreservationTarget === 'on'
                ? '_blank'
                : ''
            "
            [ngClass]="{
              'find-trip-clicked': isFindMyTripClicked,
              'last-focusable-element':
                !contentMyTrip?.mytripsCarReservationUrl &&
                !tripContent?.carReservationLabel,
              'hotel-resrv-tab-logged-in': tripContent?.carReservationLabel
            }"
            class="hotel-resrv-link-logged-in icon-advsearchtriangle"
          >
            {{
              tripContent
                ? tripContent.hotelReservationTitle
                : 'Hotel Reservations'
            }}
            <span
              *ngIf="contentMyTrip?.mytripsHotelreservationTarget === 'on'"
              class="sr-only"
            >
              opens in new window
            </span>
          </a>
          <a
            (click)="setTrackingObject($event)"
            *ngIf="tripContent?.carReservationLabel"
            [attr.href]="contentMyTrip?.mytripsCarReservationUrl"
            [attr.target]="
              contentMyTrip?.mytripsCarReservationTarget === 'on'
                ? '_blank'
                : ''
            "
            [ngClass]="{
              'find-trip-clicked': isFindMyTripClicked,
              'last-focusable-element':
                contentMyTrip?.mytripsCarReservationUrl &&
                tripContent?.carReservationLabel
            }"
            class="car-resrv-link-logged-in icon-advsearchtriangle"
          >
            {{ tripContent?.carReservationLabel }}
            <span
              *ngIf="contentMyTrip?.mytripsCarReservationTarget === 'on'"
              class="sr-only"
            >
              opens in new window
            </span>
          </a>
        </div>
      </div>
      <div
        *ngIf="!tripDetails?.hasUpComingTrip"
        [ngClass]="{ 'd-none': tripDetails?.hasUpComingTrip }"
        class="form-row"
      >
        <div
          [ngClass]="{
            'col-md-6 col-sm-10': !contentMyTrip?.mytripsCarReservationLabel,
            'col-5 col-md-4 col-sm-5': contentMyTrip?.mytripsCarReservationLabel
          }"
          class="col-lg-auto has-reservation-link resrv-link-col offset-md-2 offset-lg-0 pl-xl-0 mb-lg-1"
        >
          <a
            (click)="setTrackingObject($event)"
            *ngIf="contentMyTrip?.mytripsHotelreservationLabel"
            [attr.href]="
              contentMyTrip
                ? contentMyTrip.mytripsHotelreservationUrl
                : 'http://www.hotels-delta.com'
            "
            [attr.target]="
              contentMyTrip?.mytripsHotelreservationTarget === 'on'
                ? '_blank'
                : ''
            "
            [ngClass]="{
              'last-focusable-element':
                !contentMyTrip?.mytripsCarReservationUrl &&
                !contentMyTrip?.mytripsCarReservationLabel,
              'hotel-resrv-tab': contentMyTrip?.mytripsCarReservationLabel
            }"
            class="hotel-resrv-link icon-advsearchtriangle"
          >
            {{
              contentMyTrip
                ? contentMyTrip.mytripsHotelreservationLabel
                : 'Hotel Reservations'
            }}
            <span
              *ngIf="contentMyTrip?.mytripsHotelreservationTarget === 'on'"
              class="sr-only"
            >
              opens in new window
            </span>
          </a>
          <a
            (click)="setTrackingObject($event)"
            *ngIf="contentMyTrip?.mytripsCarReservationLabel"
            [attr.href]="contentMyTrip?.mytripsCarReservationUrl"
            [attr.target]="
              contentMyTrip?.mytripsHotelreservationTarget === 'on'
                ? '_blank'
                : ''
            "
            [ngClass]="{
              'last-focusable-element':
                contentMyTrip?.mytripsCarReservationUrl &&
                contentMyTrip?.mytripsCarReservationLabel
            }"
            class="car-resrv-link icon-advsearchtriangle"
          >
            {{ contentMyTrip?.mytripsCarReservationLabel }}
            <span
              *ngIf="contentMyTrip?.mytripsCarReservationTarget === 'on'"
              class="sr-only"
            >
              opens in new window
            </span>
          </a>
        </div>
      </div>
    </form>
    <div *ngIf="spinner" class="spinner-overlay"></div>
    <div *ngIf="spinner" class="spinner-loading">
      <div class="loader-holder"></div>
      <h2>Loading...</h2>
    </div>
  </div>
</div>
